$(document).ready(function() {
    $("li.hide").css("style","display:block;");
    //$("li#node-100080,li#node-100091,li#node-100028").empty();
    function resizeForm(){
        var width = (window.innerWidth > 0) ? window.innerWidth : document.documentElement.clientWidth;
        if(width > 1024){
          var footerOffset = $(".browse-bar").offset();
          var topX = footerOffset.top;
          //console.log(topX);
          $("#sidebar-nav").height(topX);
             } else {
          }    
      }
      window.onresize = resizeForm;
      resizeForm();
 }); 